import React, { useState, useEffect, useRef, useCallback } from "react";
import { ImageControls } from "./ImageReviewControls";
import { ModalOverlay, ModalContent } from "./ImageReview.styles";

export const ImageReviewContainer = ({ src, alt, onClose }) => {
    const [ rotation, setRotation ] = useState(0);
    const [ contentSize, setContentSize ] = useState(0);
    const [ imageScaled, setImageScaled ] = useState(false);
    const imgRef = useRef(null);
    const controlsGapPx = 60;

    const calculateRotatedSize = (width, height, angle) => {
        const radian = (angle * Math.PI) / 180;
        const sin = Math.abs(Math.sin(radian));
        const cos = Math.abs(Math.cos(radian));

        const rotatedWidth = width * cos + height * sin;
        const rotatedHeight = width * sin + height * cos;

        return { width: rotatedWidth, height: rotatedHeight };
    };

    const rotateImage = (rotation) => {
        if (imageScaled) setImageScaled(false);
        setRotation(rotation);
    }

    const updateImageWidth = useCallback(() => {
        if (imgRef.current) {
            const { naturalWidth, naturalHeight } = imgRef.current;
            const { height: rotatedHeight } = calculateRotatedSize(
                naturalWidth,
                naturalHeight,
                rotation
            );

            const maxContainerHeight = window.innerHeight * 0.9;

            let scaledWidth;
            let scaledHeight = rotatedHeight;

            if (scaledHeight > maxContainerHeight) {
                scaledHeight = maxContainerHeight + controlsGapPx;
                scaledWidth = maxContainerHeight - controlsGapPx;
            } else {
                scaledWidth = maxContainerHeight + controlsGapPx;
            }
            setContentSize({ width: scaledWidth, height: scaledHeight });
        }
    }, [ rotation ]);

    useEffect(() => {
        updateImageWidth();

        window.addEventListener("resize", updateImageWidth);
        return () => window.removeEventListener("resize", updateImageWidth);
    }, [ src, rotation, updateImageWidth ]);

    return (
        <ModalOverlay onClick={ onClose }>
            <ModalContent onClick={ e => e.stopPropagation() }
                          rotation={ rotation }
                          contentHeight={ contentSize.height }
                          contentWidth={ contentSize.width }
                          imageScaled={ imageScaled }
            >
                <ImageControls rotation={ rotation } setRotation={ rotateImage }/>
                <img ref={ imgRef }
                     src={ src }
                     alt={ alt }
                     onLoad={ updateImageWidth }
                     onClick={ () => setImageScaled(!imageScaled) }
                />
            </ModalContent>
        </ModalOverlay>
    );
};